import React from 'react'
import { getSidecarPhoneNumber } from 'sidecar-utilities'

import { SidecarPhoneNumberProps } from './SidecarPhoneNumber.types'

/**
 * A handy little component that renders the member care phone number
 * based on the product type of the member (or the default number).
 *
 * @param {string} className - Override classes for the link
 * @returns
 */
export const SidecarPhoneNumber = ({ className }: SidecarPhoneNumberProps) => {
  const phoneNumber = getSidecarPhoneNumber()

  return (
    <a
      className={className}
      data-testid="link_phoneNumber"
      href={`tel:${phoneNumber}`}
      rel="noopener noreferrer"
    >
      {phoneNumber}
    </a>
  )
}
